module.exports = __webpack_public_path__ + "src/img/artist/artist06.jpg?f1b4115250fc6a0d6c886d16591730a2";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/artist06.jpg
// module id = 113
// module chunks = 0